import React from 'react';
import { UIThemeContextType } from './types';

const UIThemeContext = React.createContext<UIThemeContextType>({
  theme: 'light',
  isDark: false,
  toggleTheme: () => {},
});

export default UIThemeContext;
